import getHours from 'date-fns/getHours';
import getMinutes from 'date-fns/getMinutes';
import parse from 'date-fns/parse';
import timeZoneData from './timezones.json';

export const defaultTimeSlot = [
  {
    day: 0,
    month: null,
    year: null,
    to: '',
    from: '',
    valid: false,
    open_all_day: false,
    custom_date: false,
  },
  {
    day: 1,
    month: null,
    year: null,
    to: '05:00 PM',
    from: '09:00 AM',
    valid: true,
    open_all_day: false,
    custom_date: false,
  },
  {
    day: 2,
    month: null,
    year: null,
    to: '05:00 PM',
    from: '09:00 AM',
    valid: true,
    open_all_day: false,
    custom_date: false,
  },
  {
    day: 3,
    month: null,
    year: null,
    to: '05:00 PM',
    from: '09:00 AM',
    valid: true,
    open_all_day: false,
    custom_date: false,
  },
  {
    day: 4,
    month: null,
    year: null,
    to: '05:00 PM',
    from: '09:00 AM',
    valid: true,
    open_all_day: false,
    custom_date: false,
  },
  {
    day: 5,
    month: null,
    year: null,
    to: '05:00 PM',
    from: '09:00 AM',
    valid: true,
    open_all_day: false,
    custom_date: false,
  },
  {
    day: 6,
    month: null,
    year: null,
    to: '',
    from: '',
    valid: false,
    open_all_day: false,
    custom_date: false,
  },
]

export const defaultTimeSlotData = [
  {
    day_of_week: 0,
    closed_all_day: true,
    open_hour: null,
    open_minutes: null,
    close_hour: null,
    close_minutes: null,
    open_all_day: false,
    custom_date: false,
    day: 0,
    month: null,
    year: null,
  },
  {
    day_of_week: 1,
    closed_all_day: false,
    open_hour: 9,
    open_minutes: 0,
    close_hour: 17,
    close_minutes: 0,
    open_all_day: false,
    custom_date: false,
    day: 1,
    month: null,
    year: null,
  },
  {
    day_of_week: 2,
    closed_all_day: false,
    open_hour: 9,
    open_minutes: 0,
    close_hour: 17,
    close_minutes: 0,
    open_all_day: false,
    custom_date: false,
    day: 2,
    month: null,
    year: null,
  },
  {
    day_of_week: 3,
    closed_all_day: false,
    open_hour: 9,
    open_minutes: 0,
    close_hour: 17,
    close_minutes: 0,
    open_all_day: false,
    custom_date: false,
    day: 3,
    month: null,
    year: null,
  },
  {
    day_of_week: 4,
    closed_all_day: false,
    open_hour: 9,
    open_minutes: 0,
    close_hour: 17,
    close_minutes: 0,
    open_all_day: false,
    custom_date: false,
    day: 4,
    month: null,
    year: null,
  },
  {
    day_of_week: 5,
    closed_all_day: false,
    open_hour: 9,
    open_minutes: 0,
    close_hour: 17,
    close_minutes: 0,
    open_all_day: false,
    custom_date: false,
    day: 5,
    month: null,
    year: null,
  },
  {
    day_of_week: 6,
    closed_all_day: true,
    open_hour: null,
    open_minutes: null,
    close_hour: null,
    close_minutes: null,
    open_all_day: false,
    custom_date: false,
    day: 6,
    month: null,
    year: null,
  },
]

export const generateTimeSlots = (step = 15) => {
  /*
    Generates a list of time strings from 12:00 AM to next 24 hours. Each new string
     will be generated by adding `step` minutes to the previous one.
    The list is generated by starting with a random day and adding step minutes till end of the same day.
  */
  const date = new Date(1970, 1, 1);
  const slots = [];
  while (date.getDate() === 1) {
    slots.push(
      date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      })
    );
    date.setMinutes(date.getMinutes() + step);
  }
  return slots;
};

export const getTime = (hour, minute) => {
  const merdian = hour > 11 ? 'PM' : 'AM';
  const modHour = hour > 12 ? hour % 12 : hour || 12;
  const parsedHour = modHour > 10 ? modHour : `0${modHour || 0}`;
  const parsedMinute = minute > 10 ? minute : `0${minute || 0}`;
  return `${parsedHour}:${parsedMinute} ${merdian}`;
};

export const timeSlotParse = timeSlots => {
  return timeSlots.map(slot => {
    const {
      day_of_week: dayOfWeek,
      open_hour: openHour,
      open_minutes: openMinutes,
      close_hour: closeHour,
      close_minutes: closeMinutes,
      closed_all_day: closedAllDay,
      open_all_day: openAllDay,
      custom_date: customDate,
      id,
      day,
      month,
      year
    } = slot;
    const from = closedAllDay ? '' : getTime(openHour, openMinutes);
    const to = closedAllDay ? '' : getTime(closeHour, closeMinutes);

    return {
      day: customDate ? day : dayOfWeek,
      month,
      year,
      to,
      id: (id !== null && id !== undefined) ? id : undefined,
      from,
      valid: !closedAllDay,
      openAllDay,
      customDate,
      closed_all_day: closedAllDay,
      open_all_day: openAllDay,
      custom_date: customDate,
    };
  });
};

export const timeSlotTransform = (timeSlots, custom_date = false,enable_weekly = true) => {
  return timeSlots.map(slot => {
    const closed = slot.closed_all_day || (!slot.open_all_day && !(slot.to && slot.from));
    const openAllDay = slot.open_all_day || slot.openAllDay;
    let fromDate = '';
    let toDate = '';
    let openHour = null;
    let openMinutes = null;
    let closeHour = null;
    let closeMinutes = null;

    if (!closed && !openAllDay) {
      fromDate = parse(slot.from, 'hh:mm a', new Date());
      toDate = parse(slot.to, 'hh:mm a', new Date());
      openHour = getHours(fromDate);
      openMinutes = getMinutes(fromDate);
      closeHour = getHours(toDate);
      closeMinutes = getMinutes(toDate);
    } else if (openAllDay || !enable_weekly) {
      openHour = 0;
      openMinutes = 0;
      closeHour = 23;
      closeMinutes = 59;
    }
    return {
      day_of_week: !custom_date ? slot.day : parseInt(`${slot.year}${slot.month}${slot.day}`, 10),
      closed_all_day: closed,
      open_hour: openHour,
      open_minutes: openMinutes,
      close_hour: closeHour,
      close_minutes: closeMinutes,
      open_all_day: openAllDay,
      custom_date: custom_date,
      day: slot.day,
      month: slot.month,
      year: slot.year,
      id: slot.id,
    };
  });
};

export const timeZoneOptions = () => {
  return Object.keys(timeZoneData).map(key => ({
    label: key,
    value: timeZoneData[key],
  }));
};
